module.exports = __webpack_public_path__ + "img/Cloud-Database.321a511.webp";